module.exports = __webpack_public_path__ + "static/media/nora-theme.5f5290d3.wav";